import React, { useRef, useState, useContext, useEffect } from 'react';
import { message, Row, Col, Upload } from 'antd';
import { saveFileToDisk } from '../../../../actions';
import JoditEditor from 'jodit-react';
import { InboxOutlined } from '@ant-design/icons';
import { Context } from '../../../../defaults';

const { Dragger } = Upload;

const Question2 = ({ data, setData, examAnswers, setExamAnswers, current }) => {
    const { dictionary, language } = useContext(Context);
    const [editorValue, setEditorValue] = useState('');
    const [file, setFile] = useState();

    // useEffect(() => {
    //     if (examAnswers && current && examAnswers[current]) {
    //         setEditorValue(examAnswers[current]);
    //     }
    // }, []);

    const editor = useRef(null);

    const onChange = (i, content) => {

        const copy = [...data.answerVariants];
        copy[i].answerHtml = content;
        setData({ ...data, answerVariants: [...copy] });


    }

    const onRemove = (file, i) => {
        const copy = [...data.answerVariants];
        const index = copy[i].files.findIndex(x => x.link === file.link);
        const newFileList = copy[i].files.slice();
        newFileList.splice(index, 1);
        copy[i].files = newFileList;
        setData({ ...data, answerVariants: [...copy] });
        console.log('file', file);
    }

    const upload = ({ file, onSuccess, index }) => {
        const copy = [...data.answerVariants];
        if (copy[index].files.length < 2) {
            const formData = new FormData();
            console.log('fileBytes', file);
            formData.append('fileBytes', file);

            saveFileToDisk(formData).then((res) => {
                onSuccess('ok');
                const fileName = file.name.split('.');
                copy[index].files.push({ link: res, extension: fileName[fileName.length - 1] });
                setData({ ...data, answerVariants: [...copy] });

            });
        }
        else {
            message.error(dictionary?.MaxFile[language]);

        }
    }
    return (
        <div>
            {
                data.answerVariants.map((el, i) => {
                    return <div key={`answer1${el.id}`} style={{ marginTop: 20 }}>
                        <div style={{ marginTop: 30 }}>
                            <JoditEditor
                                ref={editor}
                                value={el.answerHtml}
                                tabIndex={1}
                                onChange={content => onChange(i, content)}
                            />
                        </div>
                        <div style={{ marginTop: 30 }}>
                            <Dragger
                                listType="picture"
                                multiple
                                maxCount={2}
                                onRemove={(file) => onRemove(file, i)}
                                fileList={
                                    el.files ?
                                        el.files.map(x => {
                                            return { uid: x.id, name: x.link, status: 'done', url: x.link };
                                        }) :
                                        []
                                }
                                customRequest={({ file, onSuccess }) => upload({ file, onSuccess, index: i })}
                                onChange={(info) => {
                                    const { status } = info.file;
                                    if (status !== 'uploading') {
                                        console.log(info.file, info.fileList);
                                    }
                                    if (status === 'done') {
                                        message.success(dictionary?.FileSuccessfullyUploaded[language]);
                                    } else if (status === 'error') {
                                        message.error(dictionary?.FileUploadFailed[language]);
                                    }
                                }
                                }

                            >
                                <p className='ant-upload-drag-icon'>
                                    <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">{dictionary?.MaxFile[language]}</p>
                            </Dragger>
                        </div>
                    </div>
                })
            }

        </div>
    );
}

export default Question2;